const doc = [({"en":({"js":({"admin":({"ability_groups":({"table":({"the_ability_group_was_deleted":"The ability group was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;